<template>
  <div>
    <h1>My Form</h1>
    <validation-observer v-slot="{ handleSubmit }" ref="refFormObserver">
      <form @submit.prevent="handleSubmit(onSubmit)">
        <validation-provider
          #default="validationContext"
          rules="required"
          name="correo electrónico"
        >
          <b-form-group
            id="input-group-1"
            label="Email address:"
            label-for="input-1"
            description="We'll never share your email with anyone else."
          >
            <b-form-input
              id="input-1"
              type="email"
              placeholder="Enter email"
              v-model="form.email"
              :state="getValidationState(validationContext)"
            ></b-form-input>
            <b-form-invalid-feedback :state="getValidationState(validationContext)">
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
        <validation-provider #default="validationContext" rules="required" name="estatus">
          <b-form-group label="Estatus:">
            <v-select
              v-model="form.status"
              :options="[
                { value: '1', label: 'Pendiente' },
                { value: '2', label: 'Terminado' },
              ]"
              :reduce="(val) => val.value"
              placeholder="Seleccione estatus"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            />
            <b-form-invalid-feedback :state="getValidationState(validationContext)">
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
        <validation-provider #default="validationContext" rules="required" name="paises">
          <b-form-group label="Paises:">
            <v-select
              v-model="form.countries"
              :options="[
                {
                  value: 'mx',
                  label: 'Mexico',
                },
                {
                  value: 'us',
                  label: 'United States',
                }
              ]"
              :reduce="(val) => val.value"
              placeholder="Seleccione paises"
              multiple
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            />
            <b-form-invalid-feedback :state="getValidationState(validationContext)">
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
        <button type="submit">Submit</button>
      </form>
    </validation-observer>
  </div>
</template>

<script>
import { ref, watch } from "@vue/composition-api";
import vSelect from "vue-select";
import formValidation from "@core/comp-functions/forms/form-validation";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  name: "MyForm",
  components: {
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  setup() {
    const form = ref({
      email: "",
      status: "",
      countries: [],
    });

    const { refFormObserver, getValidationState } = formValidation();

    watch(form.value, () => {
      console.log({formValues: form.value});
    });

    const onSubmit = () => {
      console.log({formValues: form.value, msg: "Form submitted"});
    };

    return {
      form,
      onSubmit,
      refFormObserver,
      getValidationState,
    };
  },
};
</script>

<style></style>

